import { Routes, Route } from 'react-router-dom';

import NotFoundPage from 'pages/404';

import { routes, BaseRoute } from '../config';

import { CustomRoute } from './Route';

import { routeComponents } from './routeToComponent';

type RouteEntries = Array<[string, BaseRoute]>;

const entries = Object.entries(routes) as RouteEntries;

export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      {entries.map(([routeName, { path, isOpen, ...config }]) => (
        <Route
          key={routeName}
          path={path}
          element={
            <CustomRoute
              isPrivate={!isOpen}
              {...config}
              component={routeComponents[routeName as keyof typeof routeComponents]}
            />
          }
        />
      ))}

      <Route path="*" element={<CustomRoute isPrivate component={NotFoundPage} />} />
    </Routes>
  );
}
